import { Box } from '@mui/material'
import React from 'react';


interface PageWrapperProps {
    children?: any
}

const PageWrapper: React.FC<PageWrapperProps> = ({ children }) => {
    return (
        <Box 
            sx={{
                minHeight: "calc(100vh - 190px)", paddingLeft: "1rem", "@media (max-width: 991px)": {
                paddingLeft: "0rem"
                },
            }}
        >
            {children}
        </Box>
    )
}


export default PageWrapper